import React from 'react';
import {
  AdoptionIcon,
  DentalIcon,
  DependentCareIcon,
  LifestyleIcon,
  MedicalIcon,
  NullPlanIcon,
  ParkingIcon,
  PlanSpecificIcon,
  PremiumIcon,
  RXIcon,
  TransitIcon,
  TravelIcon,
  VisionIcon,
  WellnessIcon,
} from '@common-fe/common-fe';

import { ICategoryDtoCategoryTypeEnum } from '@/dtos/models/ICategoryDto';

interface Props {
  type?: ICategoryDtoCategoryTypeEnum;
  opacity?: string;
  size?: string;
  height?: string;
  color?: string;
}

const ServiceCategoryIcon: React.FC<Props> = ({ type, ...props }) => {
  switch (type) {
    case ICategoryDtoCategoryTypeEnum.MEDICAL:
      return <MedicalIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.DENTAL:
      return <DentalIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.VISION:
      return <VisionIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.PHARMACY:
      return <RXIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.ADOPTION:
      return <AdoptionIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.PARKING:
      return <ParkingIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.TRANSIT:
      return <TransitIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.DEPENDENT_CARE:
      return <DependentCareIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.LIFE_STYLE:
      return <LifestyleIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.WELLNESS:
      return <WellnessIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.TRAVEL:
      return <TravelIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.PLAN_SPECIFIC:
      return <PlanSpecificIcon {...props} />;
    case ICategoryDtoCategoryTypeEnum.PREMIUM:
      return <PremiumIcon {...props} />;
    default:
      return <NullPlanIcon {...props} />;
  }
};

export default ServiceCategoryIcon;
